import {
  Box,
  CircularProgress,
  colors,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Close } from "@material-ui/icons";

import ListTile from "../../../components/ListTile";
import { DefaultButton, OutlineButton } from "../../../components/Buttons";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import Paginator, { DataTypeEnum } from "../../../../../models/Paginator";
import {
  ICIPAdminActionTypeEnum,
  ICIPAdminDispatchContext,
} from "../../../../../context/ICIPAdminContext";
import { AppScrollbar } from "../../../../../components/scrollbar/AppScrollbar";
import { AddRequestCountryAttributes } from "../../../../../attributes/country-attributes";
import CountryService from "../../../../../services/CountryService";

const useStyles = makeStyles(
  (theme) => ({
    navBarSlideWrapper: {
      position: "absolute",
      height: "calc(100vh - 102px)",
      left: 0,
      top: 0,
      zIndex: 2000,
      width: 500,
      overflow: "hide",
      background: theme.palette.common.white,
    },

    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "nowrap",

      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.secondary.main,

      close: {
        color: colors.grey[800],
      },
    },

    wrapper: {},

    wrapperContent: {
      position: "relative",
      height: "calc(100vh - 102px)",
    },

    scrollableWrapper: {
      height: "calc(100vh - 172px)",
    },

    bottomWrapper: {
      position: "absolute",
      bottom: 0,
      left: 0,
      background: theme.palette.common.white,
      width: "100%",

      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },

    loader: {
      marginTop: 6,
    },
  }),
  {
    name: "add-country-form-styles",
    flip: null,
  }
);

interface AddCountryWrapperProps {
  show?: boolean;
  country: any;
  onClose: () => void;
  callback: (
    paginator: Paginator,
    countries: Array<AddRequestCountryAttributes>
  ) => void;
}

export const AddCountryWrapper = (props: AddCountryWrapperProps) => {
  const classes = useStyles(props);
  const intl = useIntl();
  // Context
  const dispatch = useContext(ICIPAdminDispatchContext);
  // State
  const [loading, setLoading] = useState(false);

  // Formik

  const addCountryRequest = () => {
    setLoading(true);

    try {
      const response = CountryService.addCountry(props.country);

      response.then((response) => {
        if (response.isSuccess) {
          switch (response.data.code) {
            case 100: // Ok
              ICIPAdminService.supportedCountries().then((response) => {
                if (response.isSuccess && response.data.code === 100) {
                  let reqPaginator = Paginator.fromJson(
                    JSON.parse(JSON.stringify(response.data.data)),
                    DataTypeEnum.countries
                  );

                  CountryService.getCountriesToAddOrUpdate().then(
                    (response) => {
                      if (response.isSuccess && response.data.code === 100) {
                        let data = JSON.parse(
                          JSON.stringify(response.data.data)
                        );

                        setLoading(false);
                        props.callback(reqPaginator, data);
                        props.onClose();
                      } else {
                        dispatch({
                          type: ICIPAdminActionTypeEnum.error,
                          data: {
                            error: intl.formatMessage({
                              id: "error.unknownError",
                            }),
                          },
                        });
                      }
                    }
                  );
                } else {
                  dispatch({
                    type: ICIPAdminActionTypeEnum.error,
                    data: {
                      error: intl.formatMessage({ id: "error.unknownError" }),
                    },
                  });
                  setLoading(false);
                }
              });
              break;
            default:
              dispatch({
                type: ICIPAdminActionTypeEnum.error,
                data: {
                  error: intl.formatMessage({ id: "error.unknownError" }),
                },
              });
              setLoading(false);
              break;
          }
        } else {
          dispatch({
            type: ICIPAdminActionTypeEnum.error,
            data: {
              error: intl.formatMessage({ id: "error.unknownError" }),
            },
          });
          setLoading(false);
        }
      });
    } catch (error) {
      dispatch({
        type: ICIPAdminActionTypeEnum.error,
        data: {
          error: intl.formatMessage({ id: "error.unknownError" }),
        },
      });
      setLoading(false);
    }
  };

  // Renders

  return (
    <>
      {props.show ? (
        <Box className={classes.navBarSlideWrapper}>
          <Box className={classes.wrapperContent}>
            <AppScrollbar>
              <Box component="div" className={classes.scrollableWrapper}>
                <Box component="div" className={classes.header}>
                  <Typography variant="h4" component="h4">
                    <FormattedMessage id="sharedScreen.addCountry" />
                  </Typography>

                  <IconButton
                    className="close"
                    onClick={(_) => props.onClose()}
                    aria-expanded={true}
                    aria-label="close"
                  >
                    <Close />
                  </IconButton>
                </Box>
                <Box component="div" className={classes.wrapper}>
                  <Box component="div" mt={3} pl={4} pr={4}>
                    <Typography variant="h3" component="h3">
                      {props.country.country_designation} (
                      {props.country.alpha_code})
                    </Typography>
                  </Box>

                  <Box component="div" mt={3}>
                    <ListTile
                      title={intl.formatMessage({ id: "sharedScreen.code" })}
                    >
                      {props.country.country_designation}
                    </ListTile>
                    <ListTile
                      title={intl.formatMessage({
                        id: "sharedScreen.countryCode",
                      })}
                    >
                      {props.country.alpha_code}
                    </ListTile>
                    <ListTile
                      title={intl.formatMessage({
                        id: "sharedScreen.callingCode",
                      })}
                    >
                      {props.country.country_dc}
                    </ListTile>
                    <ListTile
                      title={intl.formatMessage({
                        id: "sharedScreen.currency",
                      })}
                    >
                      {props.country.currency_code}
                      {props.country.currency_designation != null
                        ? ` (${props.country.currency_designation})`
                        : ""}
                    </ListTile>
                  </Box>
                </Box>
              </Box>
            </AppScrollbar>

            <Box className={classes.bottomWrapper}>
              <Box
                component="div"
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Box component="div" display="inline-block" mr={2}>
                  {loading ? (
                    <Box display="inline-block" className={classes.loader}>
                      <CircularProgress
                        color="secondary"
                        size={20}
                        thickness={4}
                      />
                    </Box>
                  ) : (
                    <OutlineButton onClick={(_) => props.onClose()}>
                      <FormattedMessage id="sharedScreen.cancel" />
                    </OutlineButton>
                  )}
                </Box>

                <Box component="div" display="inline-block">
                  <DefaultButton
                    disabled={loading}
                    onClick={(_) => addCountryRequest()}
                  >
                    <FormattedMessage id="sharedScreen.cancel" />
                  </DefaultButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

AddCountryWrapper.defaultProps = {
  show: false,
};
